const isValidUrl = (urlString: string) => {
	const urlPattern = new RegExp(
		'^(https?:\\/\\/)?' + // validate protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
			'(\\#[-a-z\\d_]*)?$',
		'i'
	); // validate fragment locator
	return !!urlPattern.test(urlString);
};

const selectElements: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.select-cta');

selectElements.forEach((select: HTMLSelectElement) => {
	select.addEventListener('change', (event: Event) => {
		const inputTarget = event.target as HTMLSelectElement;
		const fields = inputTarget.value.split('|');
		if (fields[1] && isValidUrl(fields[1])) {
			if ('_blank' === fields[0]) {
				// open new tab
				window.open(fields[1], '_blank')?.focus();
			} else {
				// open this tab
				window.location.href = fields[1];
			}
		}
	});
});
